import { useEffect, useRef } from "react";

const CODE_SNIPPETS = [
    "const", "=>", "{}", "[];", "return", "async", "await",
    "//", "</>", "===", "null", "&&", "||", "import",
    "( )", ".map()", "true", "0x1F", "npm", "git",
    "fn()", "!==", "??", "++", "**", "if()",
];

const POOL_SIZE = 20;
const MIN_DIST = 18;

export default function CursorTrail() {
    const containerRef = useRef(null);
    const lastPos = useRef({ x: 0, y: 0 });
    const poolRef = useRef([]);
    const headRef = useRef(0);
    const pendingRef = useRef(null);
    const rafRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;

        // Создаём пул заранее — никаких appendChild/removeChild во время работы
        const pool = Array.from({ length: POOL_SIZE }, () => {
            const el = document.createElement("span");
            el.style.cssText =
                "position:fixed;font-family:'Courier New',monospace;font-weight:700;" +
                "color:#B8FF65;white-space:nowrap;user-select:none;pointer-events:none;" +
                "opacity:0;text-shadow:0 0 8px rgba(184,255,101,0.6);";
            container.appendChild(el);
            return el;
        });
        poolRef.current = pool;

        const spawnParticle = (x, y) => {
            const el = pool[headRef.current % POOL_SIZE];
            headRef.current++;

            // Отменяем предыдущую анимацию этого элемента
            el.getAnimations().forEach(a => a.cancel());

            el.textContent = CODE_SNIPPETS[Math.floor(Math.random() * CODE_SNIPPETS.length)];

            const size = 9 + Math.random() * 5;
            el.style.fontSize = `${size}px`;
            el.style.left = `${x + (Math.random() - 0.5) * 24}px`;
            el.style.top  = `${y + (Math.random() - 0.5) * 14}px`;

            const driftX = (Math.random() - 0.5) * 40;
            const driftY = -(20 + Math.random() * 30);
            const startOpacity = 0.55 + Math.random() * 0.35;

            // Web Animations API — работает на compositor thread
            el.animate(
                [
                    { opacity: startOpacity, transform: "translate(0,0) scale(1)" },
                    { opacity: 0.3, transform: `translate(${driftX * 0.6}px,${driftY * 0.6}px) scale(0.85)`, offset: 0.6 },
                    { opacity: 0,   transform: `translate(${driftX}px,${driftY}px) scale(0.65)` },
                ],
                { duration: 750, easing: "ease-out", fill: "forwards" }
            );
        };

        const onMouseMove = (e) => {
            const dx = e.clientX - lastPos.current.x;
            const dy = e.clientY - lastPos.current.y;
            if (dx * dx + dy * dy < MIN_DIST * MIN_DIST) return;

            lastPos.current = { x: e.clientX, y: e.clientY };

            if (pendingRef.current) return;
            pendingRef.current = { x: e.clientX, y: e.clientY };

            rafRef.current = requestAnimationFrame(() => {
                if (pendingRef.current) {
                    spawnParticle(pendingRef.current.x, pendingRef.current.y);
                    pendingRef.current = null;
                }
            });
        };

        window.addEventListener("mousemove", onMouseMove, { passive: true });
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className="cursor-trail"
            style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 1, overflow: "hidden" }}
            aria-hidden="true"
        />
    );
}
